@if (contactId > 0) {
<section class="sticky-toolbar rounded">
    <div class="card">
        <div title="Show Alerts & Notes">
            <notes [module]="'collections,contacts'" [saleId]="saleId" [contactId]="contactId"
                [key]="'all-accounts'" (posted)="notePosted($event)" title="Show Alerts & Notes"></notes>
        </div>
    </div>
</section>
}

<div class="content">

    <div class="container-fluid">

        <div class="card-deck">
            <div class="card">
                <div class="card-body">
                    <h2 class="card-title clickable" (click)="edit($event)">{{contactName}}</h2>
                    <p class="card-subtitle text-muted">{{address}}</p>
                    <div class="card-subtitle">
                        @if (phone) {
                        <a href="tel://{{phone}}" class="card-link">{{formattedPhone}}</a>
                        }
                        @if (email) {
                        <a href="mailto:{{email}}" class="card-link">{{email}}</a>
                        }
                    </div>
                    <div class="link-bar">
                        <a href="#" class="card-link" (click)="edit($event)"><span class="material-icons">edit</span></a>
                    </div>
                </div>
            </div>

            @if (receivable && (receivable.group === 'closed')) {
                <div class="card status d-none d-xl-block">
                    <div class="card-body">
                        <span class="material-icons-outlined">lock</span>
                        <div>
                            <h2 class="card-title">{{receivable.status}}</h2>
                            <p class="card-subtitle text-muted">Account status is {{receivable.group}}</p>
                        </div>
                        <button class="btn btn-success btn-sm" (click)="reactivate($event)" [disabled]="((!receivable.bhph) || (!['repo', 'write-off', 'paid'].includes(receivable.status.toLowerCase())))">reactivate</button>
                    </div>
                </div>
            }
            @else {
                <div class="card due d-none d-xl-block" [routerLink]="['/collections', contactId]">
                    <div class="card-body">
                        <span class="material-icons" [class.text-danger]="pastDue > 0">fmd_bad</span>
                        <div>
                            <h2 class="card-title" [class.text-danger]="pastDue > 0">{{pastDue | currency}}</h2>
                            <p class="card-subtitle text-muted">Past due amount {{pastDueSince}}.</p>
                            <p class="card-subtitle">{{pastDueCategories}}</p>
                        </div>
                        @if (pastDue > 0) {
                            <button class="btn btn-danger btn-sm">pay</button>
                        }
                    </div>
                </div>
            }
        </div>

        @if (receivable && (receivable.group === 'closed')) {
            <div class="card status d-block d-xl-none">
                <div class="card-body">
                    <span class="material-icons-outlined">lock</span>
                    <div>
                        <h2 class="card-title">{{receivable.status}}</h2>
                        <p class="card-subtitle text-muted">Account status is {{receivable.group}}</p>
                    </div>
                    <button class="btn btn-success btn-sm" (click)="reactivate($event)" [disabled]="((!receivable.bhph) || (!['repo', 'write-off', 'paid'].includes(receivable.status.toLowerCase())))">reactivate</button>
                </div>
            </div>
        }
        @else {
            <div class="card-deck d-block d-xl-none">
                <div class="card due" [routerLink]="['/collections', contactId]">
                    <div class="card-body">
                        <span class="material-icons" [class.text-danger]="pastDue > 0">fmd_bad</span>
                        <div>
                            <h2 class="card-title" [class.text-danger]="pastDue > 0">{{pastDue | currency}}</h2>
                            <p class="card-subtitle text-muted">Past due amount {{pastDueSince}}.</p>
                        </div>
                        @if (pastDue > 0) {
                            <button class="btn btn-danger btn-sm">pay</button>
                        }
                    </div>
                </div>
            </div>
        }

        <div class="card-columns">

            <div class="card" id="past-due-detail">
                <div class="card-body">
                    <h2 class="card-title">Account Information</h2>
                </div>
                <div class="card-body">
                    @for (group of groupKeys; track group; let j = $index) {
                        <div class="card-header">
                            <div class="header-title-bar">
                                @if (groups[group].url) {
                                    <img [src]="groups[group].url" [alt]="groups[group].vehicle || null" />
                                }
                                @else {
                                    <span class="material-icons">{{icon(groups[group].category)}}</span>
                                }                          
                                <div>
                                    <p class="card-title">{{groups[group].title}}</p>
                                    <p class="card-subtitle text-muted">{{groups[group].subtitle}}</p>
                                </div>
                                @if (groups[group].bhph) {
                                    <report-drop-down [panel]="'forms'" [module]="'collections'" [saleId]="groups[group].saleId"></report-drop-down>
                                }
                                @else {
                                    <div class="empty"></div>
                                }
                            </div>
                            <div class="badge-bar">
                                @if (groups[group].financed) {
                                    <div class="alert alert-{{insuranceClass(groups[group])}}"
                                        [routerLink]="['/sales', groups[group].saleId, 'insurance']">
                                        {{insuranceMessage(groups[group])}}
                                    </div>
                                }
                                @if (security.permitted('collections', 'take payment', 'update')) {
                                    <div class="alert alert-secondary collect" [routerLink]="['/collections/', groups[group].contactId]">
                                        <span class="material-icons">paid</span>
                                        <span>Collections</span>
                                    </div>
                                }
                            </div>
                        </div>
                        @if (groups[group].financed) {
                            <ul class="terms">
                                <li>{{groups[group].type}} {{groups[group].method}} ({{groups[group].taxMethod}})</li>
                                <li>
                                    <span>{{groups[group].quote ? 'Quoted' : 'Sold'}}</span>
                                    <span class="numeric">{{groups[group].sold | date:'E MMM d, yyyy'}}</span>
                                </li>
                                <li>
                                    <span>Lienholder</span>
                                    <span class="numeric">{{groups[group].lienholder}}</span>
                                </li>
                                <li>
                                    <span>{{groups[group].frequency}} Payment Amount</span>
                                    <span class="numeric">{{groups[group].payment | currency }}</span>
                                </li>
                                @if (!groups[group].quote) {
                                    <li>
                                        <span>Riding Cash</span>
                                        <span class="numeric">{{groups[group].ridingCash | currency }}</span>
                                    </li>
                                }
                                <li>
                                    <span>Principal Balance</span>
                                    <span class="numeric">{{groups[group].balance | currency }}</span>
                                </li>
                                <li>
                                    <span>Tax Balance</span>
                                    <span class="numeric">{{groups[group].tax | currency }}</span>
                                </li>
                                <li>
                                    <span>Unearned Interest</span>
                                    <span class="numeric">{{groups[group].unearnedInterest | currency }}</span>
                                </li>
                                @if (!groups[group].quote) {
                                    <li>
                                        <span>Unpaid Earned Interest</span>
                                        <span class="numeric">{{groups[group].unpaidEarnedInterest | currency }}</span>
                                    </li>
                                }
                                @if (!groups[group].quote) {
                                    <li>
                                        <span>Unpaid Late Fees</span>
                                        <span class="numeric">{{groups[group].lateFees | currency }}</span>
                                    </li>
                                }
                                <li>
                                    <span>Payoff</span>
                                    <span class="numeric">{{groups[group].payoff | currency }}</span>
                                </li>
                                <li>
                                    <span>Payment Balance</span>
                                    <span class="numeric">{{groups[group].paymentBalance | currency }}</span>
                                </li>
                                <li>
                                    <span>Annual Percentage Rate</span>
                                    <span class="numeric">{{groups[group].apr | number: '1.0-4' }}%</span>
                                </li>
                                <li>
                                    <span>% Principal Paid</span>
                                    <span class="numeric">{{groups[group].percentPrincipalPaid | number: '1.0-2' }}%</span>
                                </li>
                                <li>
                                    <span>Collector</span>
                                    <form [formGroup]="form">
                                        <div class="form-group">
                                            <select id="collector" class="form-control form-control-sm" formControlName="collectorId">
                                                <option value="0">No collector</option>
                                                @for (collector of collectors; track collector.id) {
                                                    <option [value]="collector.id">{{collector.name}}</option>
                                                }
                                            </select>
                                        </div>
                                    </form>
                                </li>
                            </ul>
                        }
                        @else {
                            <ul class="terms">
                                <li>{{groups[group].type}}</li>
                                <li>
                                    <span>Sold</span>
                                    <span class="numeric">{{groups[group].sold | date:'E MMM d, yyyy'}}</span>
                                </li>
                            </ul>
                        }
                    }
                </div>

                @if (receivable && receivable.bhph) {
                    <div class="card-footer">
                        @if (receivable && ['sold', 'flag'].includes(receivable.status.toLowerCase())) {
                            <div href="#" class="alert alert-secondary" (click)="recompute($event, receivable.termsId)">Recompute Receivables</div>
                        }
                        @if (receivable && ['sold', 'flag'].includes(receivable.status.toLowerCase())) {
                            <div href="#" class="alert alert-secondary" (click)="writeOff($event)">Write-Off Sale</div>
                        }
                        @if (receivable && ['sold', 'flag', 'repo'].includes(receivable.status.toLowerCase())) {
                            <div href="#" class="alert alert-secondary" (click)="repossess($event)">Repossession Panel</div>
                        }
                    </div>
                }
            </div>

            <sale-recap [saleId]="saleId"></sale-recap>

            <associations [contactId]="contactId"></associations>

            <gps-devices [saleId]="saleId"></gps-devices>

        </div>

    </div>
</div>

<contact-modal [contactId]="contact ? contact.id : 0" [key]="'all-accounts'" [language]="language" [words]="words" (modified)="contactModified($event)"></contact-modal>
<write-off-modal [receivable]="receivable" [key]="'all-accounts'" [language]="language" [words]="words" (writtenOff)="writtenOff($event)"></write-off-modal>
<repo-modal [receivable]="receivable" [setup]="setup" [key]="'all-accounts'" [language]="language" [words]="words" (repoed)="repossessed($event)"></repo-modal>
<recompute-modal [entry]="entry" [termsId]="entryTermsId" (recomputed)="recomputed($event)"></recompute-modal>
